import { type AlgoliaRecord } from '../../../algolia'

const PACK_SIZE = 'packSize'
const PACKAGING_VARIANT = 'packagingVariant'
const VARIANT_ATTRIBUTE_SET_TYPE = 'set'

interface ProductSearchAlgoliaAccessorGetVariantsData {
  productHasMultipleVariants: boolean
}

/** We check if product is single attribute variant, having only package size or variant === set */
const productHasOnlySingleVariantAttribute = (
  algoliaProduct: AlgoliaRecord,
): boolean => {
  if (!algoliaProduct.variants || algoliaProduct.variants.length <= 1) {
    return true
  }

  const { variants } = algoliaProduct

  return variants.every((variant) => {
    return !variant.variant_attributes?.some((variantAttribute) => {
      const variantAttributeIsNotPackSizeOrPackagingVariant =
        variantAttribute.variant_attribute !== PACK_SIZE &&
        variantAttribute.variant_attribute !== PACKAGING_VARIANT

      const variantAttributeIsPackagingVariantAndValueIsNotSet =
        variantAttribute.variant_attribute === PACKAGING_VARIANT &&
        variantAttribute.value.toLowerCase() !== VARIANT_ATTRIBUTE_SET_TYPE

      return (
        variantAttributeIsNotPackSizeOrPackagingVariant ||
        variantAttributeIsPackagingVariantAndValueIsNotSet
      )
    })
  })
}

/*
  We check if the product has variants array present and if there are multiple attributes that can be selected within the variants.
 */
const productHasMultipleVariantAttributes = (
  algoliaProduct: AlgoliaRecord,
): boolean => {
  const { variants } = algoliaProduct
  if (!variants) {
    return false
  }

  return (
    !productHasOnlySingleVariantAttribute(algoliaProduct) && variants.length > 1
  )
}

export const productSearchAlgoliaAccessorGetVariantsData = (
  algoliaProduct: AlgoliaRecord,
): ProductSearchAlgoliaAccessorGetVariantsData => {
  const productHasMultipleVariants =
    productHasMultipleVariantAttributes(algoliaProduct)

  return {
    productHasMultipleVariants,
  }
}
